import { render, staticRenderFns } from "./Solutions.vue?vue&type=template&id=b54cb5d0&scoped=true"
import script from "./Solutions.vue?vue&type=script&lang=js"
export * from "./Solutions.vue?vue&type=script&lang=js"
import style0 from "./Solutions.vue?vue&type=style&index=0&id=b54cb5d0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54cb5d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b54cb5d0')) {
      api.createRecord('b54cb5d0', component.options)
    } else {
      api.reload('b54cb5d0', component.options)
    }
    module.hot.accept("./Solutions.vue?vue&type=template&id=b54cb5d0&scoped=true", function () {
      api.rerender('b54cb5d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homepage/components/Solutions.vue"
export default component.exports